import { render, staticRenderFns } from "./ProjectTaskId.vue?vue&type=template&id=5158d54c&scoped=true&lang=html&"
import script from "./ProjectTaskId.vue?vue&type=script&lang=js&"
export * from "./ProjectTaskId.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTaskId.vue?vue&type=style&index=0&id=5158d54c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5158d54c",
  null
  
)

export default component.exports